import * as React from "react"
import { useRecoilValue } from "recoil"
import { Tooltip } from "../../common/tooltip"
import { brandingSelector } from "../../../recoil/atoms/room"
import useOnClickWithTouchHandler from "../../../hooks/useOnClickWithTouchHandler"
import { localMuteAtom } from "../../../recoil/atoms/local-mute"
import useLocalSpeakerMute from "../../../hooks/multimedia/useLocalSpeakerMute"
import { rtcAutoplayFailedState } from "../../../recoil/atoms/rtcAutoplayFailed"
import {
  ContainerIcon,
  MuteButton,
  VolumeIcon,
  MuteIcon
} from "../videoPlayer/custom-player.styled"
import { useWatchParty } from "../../../hooks/useWatchParty"

interface GlobalLocalMuteIconProps {}

const _LocalMuteIcon: React.FC<GlobalLocalMuteIconProps> = () => {
  const isMuted = useRecoilValue(localMuteAtom)
  const roomStyles = useRecoilValue(brandingSelector)
  const { isHost } = useWatchParty()
  const isAutoplayFailed = useRecoilValue(rtcAutoplayFailedState)

  const { toggleLocalSpeaker } = useLocalSpeakerMute()

  const toggleMuteState = React.useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()
    toggleLocalSpeaker()
  }, [toggleLocalSpeaker])
 
  const toggleMute = useOnClickWithTouchHandler(toggleMuteState)

  // isAutoplayFailed - show muted icon if RTC autoplay failed
  const muteStatus = isMuted || isAutoplayFailed

  return (
    <Tooltip label={"Local audio"} placement="bottom" isDisabled={!isHost}>
      <MuteButton id="local-mute-button" {...toggleMute} roomStyles={roomStyles}>
        <ContainerIcon roomStyles={roomStyles}>
          {muteStatus ? <MuteIcon /> : <VolumeIcon />}
        </ContainerIcon>
      </MuteButton>
    </Tooltip>
  )
}

export const LocalMuteIcon = _LocalMuteIcon
